<template>
  <div class="allSearch_w d_flex">
    <el-input
      v-model="sInput"
      placeholder="输入项目名称快速搜索"
      style="width:100%"
      clearable
    />
    <el-button
      slot="append"
      :disabled="sInput===''"
      @click="onSearch"
    >搜索</el-button>
  </div>
</template>

<script>
import { search_auctions } from '@/api/portal'
export default {
  data() {
    return {
      that: null,
      sInput: '',
      sSelect: '',
      queryResult: []
    }
  },
  mounted() {
    this.that = this
  },
  methods: {
    async onSearch() {
      this.$router.push({
        path: '/search',
        query: {
          wd: this.sInput
        }
      })

      // const { data } = await search_auctions({ keyword: this.sInput })
      // this.queryResult = data.list.map(i => {
      //   return {
      //     value: i.title
      //   }
      // })
    },

    queryAsync(queryString, cb) {
      if (!queryString) {
        cb([])
        return
      }

      this.onSearch()

      setTimeout(() => {
        cb(this.queryResult || [])
      }, 200)
    }
  }
}
</script>

<style lang="scss" scoped>
.allSearch_w {
  width: 375px;
  ::v-deep .el-button {
    height: 36px;
    line-height: 36px;
    padding: 0 20px;
    color: #fff;
    background-color: #0983cc;
    border-color: #0983cc;
    &:hover {
      background-color: rgba($color: #0983cc, $alpha: 0.9);
      border-color: rgba($color: #0983cc, $alpha: 0.9);
    }
    &.is-disabled{
      background-color: rgba($color: #0983cc, $alpha: 0.7);
      border-color: transparent;

    }
  }
}
::v-deep .el-input__inner {
  height: 36px;
  line-height: 36px;
  font-size: 14px;
  ::-webkit-input-placeholder {
    font-size: 14px;
  }
}
</style>
